import { getPreloaderFnContext } from '@confluence/query-preloader-tools/entry-points/preloaderFnContext.ts';
import { getRemoteLocalStorage } from '@confluence/storage-manager/entry-points/getRemoteLocalStorage.ts';

export async function preloadLocalStorage(): Promise<any> {
	const { userId, isLicensed } = getPreloaderFnContext();
	return getRemoteLocalStorage({
		userId,
		isLicensed,
	});
}
